import React, { FC } from 'react';
import { TypePressReleaseSnippetFields } from '@/core/generated-types';
import { RichText } from '@/components';
import { Document } from '@contentful/rich-text-types';
import styles from '@/components/common/PressReleaseSnippet/PressReleaseSnippet.module.scss';

const grayScaleLogo =
  'https://images.ctfassets.net/0sea1vycfyqy/X9ihVZZcHLDcZOJ2sJiuS/af4064c7d9074051806b4ff8eb9cba8b/logo_grayscale.webp';

export const PressReleaseSnippet: FC<TypePressReleaseSnippetFields> = ({
  entryName,
  heading,
  date,
  richText,
}) => {
  return (
    <section
      data-testid={`press-release-snippet-${entryName}`}
      className="section mx-auto border-b border-solid border-gray-400 px-4 py-10 lg:py-16"
    >
      <div className="grid grid-cols-[60px_auto] gap-4 lg:grid-cols-[90px_auto] lg:gap-8">
        <div
          className="bg-[length:60px_15px] bg-no-repeat lg:bg-[length:90px_23px]"
          style={{ backgroundImage: `url(${grayScaleLogo})` }}
        ></div>
        <div>
          <div className="mb-3 text-base lg:text-lg">
            <span className="font-bold">{heading}</span>
            <span className="ml-2 inline-block">{date}</span>
          </div>

          <div className={styles.pressReleaseSnippet}>
            <RichText content={richText as Document} />
          </div>
        </div>
      </div>
    </section>
  );
};
